const commonVideoBitrates = [
  { label: 'Audio Only', value: 10000, serial_prefixes: ['l', 'n', 'o', 'p'] },
  { label: '300 kbps', value: 300000, serial_prefixes: ['l', 'n', 'o', 'p'] },
  { label: '500 kbps', value: 500000, serial_prefixes: ['l', 'n', 'o', 'p'] },
  { label: '700 kbps', value: 700000, serial_prefixes: ['l', 'n', 'o', 'p'] },
  { label: '900 kbps', value: 900000, serial_prefixes: ['l', 'n', 'o', 'p'] },
  { label: '1.2 Mbps', value: 1200000, serial_prefixes: ['l', 'n', 'o', 'p'] },
  { label: '1.5 Mbps', value: 1572864, serial_prefixes: ['l', 'n', 'o', 'p'] },
  { label: '2.0 Mbps', value: 2000000, serial_prefixes: ['l', 'n', 'o', 'p'] },
  { label: '2.5 Mbps', value: 2500000, serial_prefixes: ['l', 'n', 'o', 'p'] },
  { label: '3.0 Mbps', value: 3000000, serial_prefixes: ['l', 'n', 'o', 'p'] },
  { label: '4.0 Mbps', value: 4000000, serial_prefixes: ['l', 'n', 'o', 'p'] },
  { label: '4.8 Mbps', value: 4800000, serial_prefixes: ['l', 'n', 'o'] },
  { label: '5.0 Mbps', value: 5000000, serial_prefixes: ['p'] },
  { label: '6.0 Mbps', value: 6000000, serial_prefixes: ['p'] },
  { label: '7.0 Mbps', value: 7000000, serial_prefixes: ['p'] },
  { label: '8.0 Mbps', value: 8000000, serial_prefixes: ['p'] },
  { label: '9.0 Mbps', value: 9000000, serial_prefixes: ['p'] },
  { label: '10.0 Mbps', value: 10000000, serial_prefixes: ['p'] },
  { label: '11.0 Mbps', value: 11000000, serial_prefixes: ['p'] },
  { label: '12.0 Mbps', value: 12000000, serial_prefixes: ['p'] },
  { label: '13.0 Mbps', value: 13000000, serial_prefixes: ['p'] },
  { label: '14.0 Mbps', value: 14000000, serial_prefixes: ['p'] },
  { label: '15.0 Mbps', value: 15000000, serial_prefixes: ['p'] },
  { label: '16.0 Mbps', value: 16000000, serial_prefixes: ['p'] },
  { label: '17.0 Mbps', value: 17000000, serial_prefixes: ['p'] },
  { label: '18.0 Mbps', value: 18000000, serial_prefixes: ['p'] },
];
const boxcasterVideoBitrates = [
  { label: 'Auto-detect', value: 'default', serial_prefixes: ['l', 'n', 'o', 'p'] },
].concat(commonVideoBitrates);
const streamVideoBitrates = [
  { label: 'Default', value: 'default', serial_prefixes: ['l', 'n', 'o', 'p'] },
].concat(commonVideoBitrates);

const commonAudioBitrates = [
  { label: '48 kbps', value: 48000, serial_prefixes: ['l', 'n', 'o'] },
  { label: '64 kbps', value: 64000, serial_prefixes: ['l', 'n', 'o'] },
  { label: '96 kbps', value: 96000, serial_prefixes: ['l', 'n', 'o', 'p'] },
  { label: '128 kbps', value: 128000, serial_prefixes: ['l', 'n', 'o', 'p'] },
  { label: '192 kbps', value: 192000, serial_prefixes: ['p'] },
  { label: '256 kbps', value: 256000, serial_prefixes: ['p'] },
  { label: '320 kbps', value: 320000, serial_prefixes: ['p'] },
];
const boxcasterAudioBitrates = [
  { label: 'Auto-detect', value: 'default', serial_prefixes: ['l', 'n', 'o', 'p'] },
].concat(commonAudioBitrates);
const streamAudioBitrates = [
  { label: 'Default', value: 'default', serial_prefixes: ['l', 'n', 'o', 'p'] },
].concat(commonAudioBitrates);

export const VideoAudioConfig = {
  boxcaster: {
    video_bitrates: boxcasterVideoBitrates,
    audio_bitrates: boxcasterAudioBitrates,
  },
  stream: {
    video_bitrates: streamVideoBitrates,
    audio_bitrates: streamAudioBitrates,
  },
};



// WEBPACK FOOTER //
// ./app/utils/video-and-audio-config.js